import { Confidence } from '../types/detection.js';
export function classifyConfidence(matchType, similarity) {
    if (matchType === 'exact' || matchType === 'synonym') {
        return Confidence.Present;
    }
    if (matchType === 'derived' && similarity >= 0.9) {
        return Confidence.Possible;
    }
    if (matchType === 'derived' && similarity < 0.9) {
        return Confidence.NeedsReview;
    }
    if (matchType === 'partial') {
        return Confidence.NeedsReview;
    }
    return Confidence.NeedsReview;
}
//# sourceMappingURL=classifyConfidence.js.map